module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "nav"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-container"
  }, [_c('div', {
    staticClass: "navbar-logo",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "schedule-menu mobile-schedule-menu"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mobile-hamburger",
    class: {
      open: _vm.open
    }
  }, [_c('div', {
    attrs: {
      "id": "nav-collapse"
    },
    on: {
      "click": _vm.toggleOpen
    }
  }, [_c('div', {
    staticClass: "bar1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar3"
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeOutside),
      expression: "closeOutside"
    }],
    staticClass: "navbar-menu"
  }, [_c('ul', {
    staticClass: "main-menu"
  }, [_c('li', {
    staticClass: "main-menu-li about",
    on: {
      "click": function($event) {
        _vm.toggleMenu("about"), _vm.isActive("about")
      }
    }
  }, [_c('span', {
    staticClass: "menu-span",
    class: {
      notActive: _vm.active.about
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-ul",
    class: {
      visible: !_vm.nav.about
    },
    attrs: {
      "id": "about"
    }
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/about",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "about",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Mission")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/team",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "team",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Our Team")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://blog.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "blog",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Blog")])])])]), _vm._v(" "), _c('li', {
    staticClass: "main-menu-li",
    on: {
      "click": function($event) {
        _vm.toggleMenu("products"), _vm.isActive("products")
      }
    }
  }, [_c('span', {
    staticClass: "menu-span",
    class: {
      notActive: _vm.active.products
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-ul",
    class: {
      visible: !_vm.nav.products
    },
    attrs: {
      "id": "products"
    }
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-2",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-2",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Robot")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/modules",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tempmod",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Temp Module")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/modules#magnetic_module",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "magmod",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Magnetic Module")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/pipettes",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-2-pipettes",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Pipettes")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/opentrons-tips",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tips",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Pipette Tips")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/racks-and-adapters",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tube-racks",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Racks & Adapters")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/mag-bead-kits",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "reagents",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Reagents")])]), _vm._v(" "), _c('a', {
    staticClass: "blue blue-products",
    attrs: {
      "href": "https://shop.opentrons.com",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "all-products",
      "data-gtm-action": "click"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Shop all products ›")])])]), _vm._v(" "), _c('li', {
    staticClass: "main-menu-li",
    on: {
      "click": function($event) {
        _vm.toggleMenu("applications"), _vm.isActive("applications")
      }
    }
  }, [_c('span', {
    staticClass: "menu-span",
    class: {
      notActive: _vm.active.applications
    }
  }, [_vm._v("Applications")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-ul",
    class: {
      visible: !_vm.nav.applications
    },
    attrs: {
      "id": "applications"
    }
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/pcr-sample-prep",
      "data-gtm-category": "p-header",
      "data-gtm-label": "prep",
      "data-gtm-action": "click"
    }
  }, [_vm._v("PCR Sample Prep")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/nucleic-acid-cleanup",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "nac",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Nucleic Acid Cleanup")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/Sample%20Prep/PCR",
      "data-gtm-category": "p-header",
      "data-gtm-label": "qpcr",
      "data-gtm-action": "click"
    }
  }, [_vm._v("qPCR/RT-PCR")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25",
      "data-gtm-category": "p-header",
      "data-gtm-label": "elisa",
      "data-gtm-action": "click"
    }
  }, [_vm._v("ELISA")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/NGS%20Library%20Prep",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ngs-prep",
      "data-gtm-action": "click"
    }
  }, [_vm._v("NGS Library Prep")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/Basic%20Pipetting",
      "data-gtm-category": "p-header",
      "data-gtm-label": "basic",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Basic Pipetting")])])])]), _vm._v(" "), _c('li', {
    staticClass: "main-menu-li",
    on: {
      "click": function($event) {
        _vm.toggleMenu("protocols"), _vm.isActive("protocols")
      }
    }
  }, [_c('span', {
    staticClass: "menu-span",
    class: {
      notActive: _vm.active.protocols
    }
  }, [_vm._v("Protocols")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-ul protocol-nav",
    class: {
      visible: !_vm.nav.protocols
    },
    attrs: {
      "id": "protocols"
    }
  }, [_c('div', {
    staticClass: "navbar-ul-div"
  }, [_c('div', {
    staticClass: "protocol-items"
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/protocols",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-tools",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Options")]), _vm._v(" "), _c('span', [_vm._v("Gain an overview of our protocol creation options")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/protocols/designer",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-designer",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Designer")]), _vm._v(" "), _c('span', [_vm._v("Use our graphical user interface to design protocols")])]), _vm._v(" "), _c('li', {
    staticClass: "protocol-bottom",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Library")]), _vm._v(" "), _c('span', [_vm._v("Explore our open source database of protocols")])])]), _vm._v(" "), _c('div', {
    staticClass: "protocol-items"
  }, [_c('li', {
    staticClass: "protocol-items-li",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://docs.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "opentrons-api",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Python API")]), _vm._v(" "), _c('span', {
    staticClass: "protocol-items-span"
  }, [_vm._v("\n                      Maximum customization for anyone with python and basic\n                      wetlab skills\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "protocol-items-li",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/Opentrons",
      "data-gtm-category": "p-header",
      "data-gtm-label": "github-protocols",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Github")]), _vm._v(" "), _c('span', {
    staticClass: "protocol-items-span"
  }, [_vm._v("Contribute to open source protocol repository")])])])]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    staticClass: "blue",
    attrs: {
      "href": "https://opentrons.com/request-protocol",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "request-protocol-protocols",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Request a free custom protocol ›")])])])]), _vm._v(" "), _c('li', {
    staticClass: "main-menu-li",
    on: {
      "click": function($event) {
        _vm.toggleMenu("sns"), _vm.isActive("sns")
      }
    }
  }, [_c('span', {
    staticClass: "menu-span",
    class: {
      notActive: _vm.active.sns
    }
  }, [_vm._v("Support & Sales")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-ul protocol-nav sns",
    class: {
      visible: !_vm.nav.sns
    },
    attrs: {
      "id": "sns"
    }
  }, [_c('div', {
    staticClass: "navbar-ul-li"
  }, [_c('div', {
    staticClass: "protocol-items"
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('span', {
    staticClass: "support-sales"
  }, [_vm._v("SUPPORT")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://support.opentrons.com/guide-for-getting-started-with-the-ot-2",
      "data-gtm-category": "p-header",
      "data-gtm-label": "start-guide",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Start Guide")]), _vm._v(" "), _c('span', [_vm._v("You received your robot, here's what's next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://support.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "product-help",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Product Help")]), _vm._v(" "), _c('span', [_vm._v("Answer common technical questions")])]), _vm._v(" "), _c('li', {
    staticClass: "github",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/Opentrons",
      "data-gtm-category": "p-header",
      "data-gtm-label": "github-support",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Github")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-ul-li"
  }, [_c('div', {
    staticClass: "protocol-items"
  }, [_c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('span', {
    staticClass: "support-sales"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://labware.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "labware-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Labware Library")]), _vm._v(" "), _c('span', [_vm._v("\n                      Understand what labware is compatible with the\n                      OT-2\n                    ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('span', {
    staticClass: "support-sales"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy",
      "data-gtm-category": "p-header",
      "data-gtm-label": "return_policy",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Warranty & Returns")]), _vm._v(" "), _c('span', [_vm._v("\n                      100% risk free returns and a quality-backed\n                      warranty\n                    ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-app",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-app",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Install the app")])]), _vm._v(" "), _c('a', {
    staticClass: "blue-text",
    attrs: {
      "href": "https://opentrons.com/contact-support",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-support",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact support ›")])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-ul-li order-online"
  }, [_c('div', {
    staticClass: "protocol-items"
  }, [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "support-sales"
  }, [_vm._v("SALES")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://shop.opentrons.com",
      "data-gtm-category": "p-header",
      "data-gtm-label": "shop",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Order online")])]), _vm._v(" "), _c('a', {
    staticClass: "blue-text",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://opentrons.com/contact",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-sales",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact sales ›")])]), _vm._v(" "), _c('a', {
    staticClass: "btn schedule-demo",
    attrs: {
      "data-gtm-category": "p-header",
      "data-gtm-label": "cta-demo-button",
      "data-gtm-action": "click",
      "href": "https://opentrons.com/demo",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Schedule a demo ›")])])])])]), _vm._v(" "), _vm._m(3, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "div-sub-menu"
  }, [_c('div', {
    staticClass: "mobile-menu",
    class: {
      mobilemenufixed: _vm.menu, dnone: !_vm.open
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu('about')
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu('products')
      }
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu('applications')
      }
    }
  }, [_vm._v("Applications")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu('protocols')
      }
    }
  }, [_vm._v("Protocols")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu('sns')
      }
    }
  }, [_vm._v("Support & Sales")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-button",
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://opentrons.com/contact",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-sales-primary",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact Sales")])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-menu about",
    class: {
      showmenu: _vm.mobileNav.about, dnone: !_vm.open
    }
  }, [_c('div', {
    staticClass: "sub-menu-div",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/arrow-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("About")])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/about",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "about",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Mission ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/team",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "team",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Our Team ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://blog.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "blog",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Blog ›")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-menu products",
    class: {
      showmenu: _vm.mobileNav.products, dnone: !_vm.open
    }
  }, [_c('div', {
    staticClass: "sub-menu-div",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/arrow-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Products")])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-2",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-2",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Robot ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/modules",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tempmod",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Temp Module")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/modules",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "magmod",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Magnetic Module ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/pipettes",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-2-pipettes",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Pipettes ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/opentrons-tips",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tips",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Pipette Tips ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/racks-and-adapters",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "tube-racks",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Racks & Adapters ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://shop.opentrons.com/collections/mag-bead-kits",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "reagents",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Reagents ›")])]), _vm._v(" "), _c('li', {
    staticClass: "blue",
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    staticClass: "blue",
    attrs: {
      "href": "https://shop.opentrons.com",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "all-products",
      "data-gtm-action": "click"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Shop all products ›")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-menu applications",
    class: {
      showmenu: _vm.mobileNav.applications, dnone: !_vm.open
    }
  }, [_c('div', {
    staticClass: "sub-menu-div",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/arrow-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Applications")])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/pcr-sample-prep",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "prep",
      "data-gtm-action": "click"
    }
  }, [_vm._v("PCR Sample Prep ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/nucleic-acid-cleanup",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "nac",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Nucleic Acid Cleanup")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/Sample%20Prep/PCR",
      "data-gtm-category": "p-header",
      "data-gtm-label": "qpcr",
      "data-gtm-action": "click"
    }
  }, [_vm._v("qPCR/RT-PCR ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/protocol/TSH_ELISA_2018-1-25",
      "data-gtm-category": "p-header",
      "data-gtm-label": "elisa",
      "data-gtm-action": "click"
    }
  }, [_vm._v("ELISA ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/NGS%20Library%20Prep",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ngs-prep",
      "data-gtm-action": "click"
    }
  }, [_vm._v("NGS Library Prep ›")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com/categories/Basic%20Pipetting",
      "data-gtm-category": "p-header",
      "data-gtm-label": "basic",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Basic Pipetting ›")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-menu protocols",
    class: {
      showmenu: _vm.mobileNav.protocols, dnone: !_vm.open
    }
  }, [_c('div', {
    staticClass: "sub-menu-div",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/arrow-icon.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Protocols")])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/protocols",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-tools",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Options ›")]), _vm._v(" "), _c('span', [_vm._v("Gain an overview of our protocol creation options")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/protocols/designer",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-designer",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Designer ›")]), _vm._v(" "), _c('span', [_vm._v("Use our graphical user interface to design protocols")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://protocols.opentrons.com",
      "data-gtm-category": "p-header",
      "data-gtm-label": "protocol-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Library ›")]), _vm._v(" "), _c('span', [_vm._v("Explore our open source database of protocols")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://docs.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "opentrons-api",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Python API ›")]), _vm._v(" "), _c('span', [_vm._v("\n                Maximum customization for anyone with python and basic weblab\n                skills\n              ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/Opentrons",
      "data-gtm-category": "p-header",
      "data-gtm-label": "github-protocols",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Github ›")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    staticClass: "blue",
    attrs: {
      "href": "https://opentrons.com/request-protocol",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "request-protocol-protocols",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Request a free custom protocol ›")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-menu sns",
    class: {
      showmenu: _vm.mobileNav.sns, dnone: !_vm.open
    }
  }, [_c('div', {
    staticClass: "sub-menu-div",
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)]), _vm._v(" "), _c('ul', {
    staticClass: "sns-ul"
  }, [_c('section', {
    staticClass: "sns-sales"
  }, [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_vm._m(6, false, false)]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.close
    }
  }, [_vm._m(7, false, false)]), _vm._v(" "), _vm._m(8, false, false)]), _vm._v(" "), _c('section', {
    staticClass: "sns-support"
  }, [_c('li', {
    on: {
      "click": _vm.close
    }
  }, [_vm._m(9, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(10, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(11, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(12, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(13, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(14, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "sns-support-li",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(15, false, false)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "docs-navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-div"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://docs.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-toolbar",
      "data-gtm-label": "opentrons-api",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Python API")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://labware.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-toolbar",
      "data-gtm-label": "labware-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Labware Library")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-toolbar",
      "data-gtm-label": "protocol-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Library")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://designer.opentrons.com/",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-toolbar",
      "data-gtm-label": "protocol-designer",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Protocol Designer")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand",
    attrs: {
      "href": "https://opentrons.com/",
      "title": "Home",
      "data-gtm-category": "p-header",
      "data-gtm-label": "logo",
      "data-gtm-action": "click"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png",
      "alt": "Opentrons Home"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule-div"
  }, [_c('a', {
    staticClass: "btn schedule-demo",
    attrs: {
      "href": "https://opentrons.com/contact",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-sales",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact sales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule-menu desktop-schedule-menu"
  }, [_c('div', {
    staticClass: "schedule-div"
  }, [_c('a', {
    staticClass: "btn schedule-demo",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://opentrons.com/contact",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-sales-primary",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact Sales")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sns-arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/arrow-icon.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sns-span"
  }, [_c('span', [_vm._v("Support & Sales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section"
  }, [_c('span', {
    staticClass: "sales-tron"
  }, [_vm._v("SALES")]), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    staticClass: "order-line-mobile",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://shop.opentrons.com",
      "data-gtm-category": "p-header",
      "data-gtm-label": "shop",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Order online ›")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section"
  }, [_c('span', {
    staticClass: "sales-tron mobile-contact"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "sales-link mobile-contact-sales",
    attrs: {
      "href": "https://opentrons.com/contact",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-sales",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact sales ›")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('section', {
    staticClass: "sns-support-section"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "sales-link schedule-demo-mobile",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "schedule-demo",
      "data-gtm-action": "click",
      "href": "https://opentrons.com/demo"
    }
  }, [_vm._v("Schedule a demo ›")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }, [_vm._v("SUPPORT")]), _vm._v(" "), _c('div', {
    staticClass: "ot-2-start-guide support-items"
  }, [_c('a', {
    staticClass: "ot-2-guide",
    attrs: {
      "href": "https://support.opentrons.com/guide-for-getting-started-with-the-ot-2",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "start-guide",
      "data-gtm-action": "click"
    }
  }, [_vm._v("OT-2 Start Guide ›")]), _vm._v(" "), _c('span', {
    staticClass: "ot-2-guide"
  }, [_vm._v("You received your robot, here's what's next")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://support.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "product-help",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Product Help ›")]), _vm._v(" "), _c('span', [_vm._v("Answer common technical questions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://github.com/Opentrons",
      "data-gtm-category": "p-header",
      "data-gtm-label": "github-support",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Github ›")]), _vm._v(" "), _c('span', [_vm._v("Contribute to open source protocol repository")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://labware.opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "labware-library",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Labware Library ›")]), _vm._v(" "), _c('span', [_vm._v("\n                      Understand what labware is compatible with the\n                      OT-2\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://support.opentrons.com/shipping-and-handling-return-policy/what-is-your-return-warranty-policy",
      "data-gtm-category": "p-header",
      "data-gtm-label": "return_policy",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Warranty & Returns ›")]), _vm._v(" "), _c('span', [_vm._v("100% risk free returns and a quality-backed warranty")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', {
    staticClass: "support-items"
  }, [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-app",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": "p-header",
      "data-gtm-label": "ot-app",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Install the app ›")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sns-support-section ot-2"
  }, [_c('span', {
    staticClass: "sales-tron"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "blue-text sales-link",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://opentrons.com/contact-support",
      "data-gtm-category": "p-header",
      "data-gtm-label": "contact-support",
      "data-gtm-action": "click"
    }
  }, [_vm._v("Contact support ›")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40aa51d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 154
// module chunks = 2